import React from "react";
import { connect } from "react-redux";
import { Switch, Route } from "react-router-dom";
import Header from "../template/header/Header.jsx";
import SideBar from "../template/sidebar/SideBar.jsx";
import MenuItem from "../template/sidebar/MenuItem.jsx";
import MenuTree from "../template/sidebar/MenuTree.jsx";
import ContentWrapper from "../componentes/ContentWrapper.jsx";
import Cookies from "../../lib_react_frontend/utils/Cookies.jsx";
import GenericApi from "../../lib_react_frontend/utils/GenericApi";
import ApiceValidadorSessao from "../../lib_react_frontend/componentes/ApiceValidadorSessao.jsx";
import Input from "../componentes/Input.jsx";
import ModalUsuarioPreferencias from "../componentes/modais/ModalUsuarioPreferencias/index.jsx";
import ModalAlterarSenha from "./ModalAlterarSenha.jsx";
import Api from "../../utils/Api.jsx";
import constants from "../../utils/constants";

/**
 * Tela da aplicação.
 */
class App extends React.Component {

  state = {
    dt_ultima_sincronizacao: '00:00',
  }

  async componentWillMount() {
    document.body.className =
      (global.app.options.skin
        ? global.app.options.skin
        : " skin-blue-light ") +
      " sidebar-mini " +
      (global.app.options.iniciarAberto ? "" : "sidebar-collapse");
    const ret = await GenericApi.validarAuth();
    if (ret.status) {
      this.props.dispatch({
        type: "on_login",
        usuario: ret.dados.usuario,
      });
    }

    if (Cookies.get("empresa")) {  
      const cod_empresa = Cookies.get("empresa"); 
      if (cod_empresa.cod_empresa_dashboard != '') {
        const ultima_sincronizacao = await Api.buscar("ultima_sincronizacao", '', cod_empresa.cod_empresa_dashboard);
        if (ultima_sincronizacao.status) {
        
        } 

      }
    
 
    }
 
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.mudarSenha != this.props.mudarSenha) {
      this.modalSenha.getWrappedInstance().show();
    }
    if (nextProps.preferencias != this.props.preferencias) {
      this.modalPreferencias.show();
    }
  }

  onChangeFiltro(e) {
    this.props.dispatch({
      type: "on_filtrar_itens",
      valor: e.target.value,
    });
  }

  getConteudo() {
    const createItem = (rota, label, icone, render, children, notBotao) => ({
      rota,
      label,
      icone,
      render,
      children,
      notBotao,
    });
    return global.app.menus(this.props.redux, createItem).filter((x) => x);
  }

  /**
   * Realiza o logout da aplicação, isso apaga o token de autenticação
   * e retorna à pagina de login.
   */
  realizarLogout() {
    if (this.props.socket) {
      this.props.socket.logoutUsuario();
    }

    Cookies.erase(global.app.cookie);
    this.props.history.push("/");
  }

  onPreferencias() {
    this.modalPreferencias.show();
  }

  renderMenuItens() {
    return this.getConteudo().map((x) =>
      x.children ? (
        <MenuTree key={x.rota} label={x.label} icon={x.icone}>
          {x.children.map((q) => (
            <MenuItem
              key={q.rota}
              path={"/app/" + x.rota + "/" + q.rota}
              label={q.label}
              icon={q.icone}
            />
          ))}
        </MenuTree>
      ) : (
        x.rota &&
        !x.notBotao && (
          <MenuItem
            key={x.rota}
            path={"/app/" + x.rota}
            label={x.label}
            icon={x.icone}
          />
        )
      )
    );
  }

  renderRoutes() {
    const conteudos = this.getConteudo();
    const routes = [];
    for (const conteudo of conteudos) {
      if (conteudo.children) {
        for (const child of conteudo.children) {
          routes.push(
            <Route
              exact
              key={child.rota}
              path={"/app/" + conteudo.rota + "/" + child.rota}
              component={child.render || ContentWrapper}
            />
          );
        }
      } else {
        routes.push(
          <Route
            exact={!conteudo.notBotao}
            key={conteudo.rota}
            path={"/app/" + conteudo.rota}
            component={conteudo.render || ContentWrapper}
          />
        );
      }
    }
    return routes;
  }

  render() { 

    const { pathname } = this.props.history.location;
  
    const acessandoUsuarioOuEmpresa =
      pathname.startsWith("/app/usuario") || pathname.startsWith("/app/empresa");
    
    const naoEhAdmin = this.props.usuario.tipo_usuario != constants.tipo_usuario_admin
  
    if (naoEhAdmin && acessandoUsuarioOuEmpresa) {
      this.props.history.push("/app/dashboard");
    }

    
    return (
      <ApiceValidadorSessao history={this.props.history}>
        <Header
          tituloGrande={global.app.nomeAplicacao}
          dados_empresa={
            this.props.dados_empresa ? this.props.dados_empresa : ""
          }
          // dt_ultima_sincronizacao={this.state.dt_ultima_sincronizacao}
          tituloPequeno={<i className={"fa " + global.app.icone} />}
          icon={global.app.icone}
          usuario={{}}
          // rota={
          //   global.app.options.landingPage
          //     ? "/" + global.app.options.landingPage
          //     : "/app"
          // }
          onLogout={this.realizarLogout.bind(this)}
          onPreferencias={this.onPreferencias.bind(this)}
          empresa={this.props.empresa}
          dt_hr_ultima_sincronizacao={this.props.ultimaAtualizacao.dt_hr_ultima_sincronizacao}
        />  
        
        <SideBar
         corPrincipal={this.props.ultimaAtualizacao.cor_principal || '#3c8dbc'}
         > 
        {/* <SideBar corPrincipal={this.props.empresa.cor_principal || '#3c8dbc'}>  */}
          {global.app.options.usarFiltro && (
            <Input
              value={this.props.filtroItens}
              placeholder="Pesquisar"
              onChange={this.onChangeFiltro.bind(this)}
            />
          )}
          {this.renderMenuItens()}
        </SideBar>

        <Switch>
          {this.renderRoutes()}
          <Route component={ContentWrapper} />
        </Switch>

        <ModalAlterarSenha ref={(e) => (this.modalSenha = e)} />

        <ModalUsuarioPreferencias
          erencias
          ref={(e) => (this.modalPreferencias = e)}
          dispatch={this.props.dispatch}
          usuario={this.props.usuario}
          empresa_selecionada={this.props.empresa}
          ultimaAtualizacao={this.props.ultimaAtualizacao}
        />
      </ApiceValidadorSessao>
    );
  }
}

export default connect(
  (state) => ({
    usuario: state.usuario,
    redux: state,
    mudarSenha: state.mudarSenha,
    dados_empresa: state.dados_empresa,
    empresa: state.empresa,
    socket: state.socket,
    ultimaAtualizacao: state.ultimaAtualizacao,
  }),
  (dispatch) => ({
    dispatch,
  })
)(App);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/main/App.jsx